/**
 * Site API client (SSOT for /client/<id>/sites + /sites/<id>).
 *
 * Thin domain wrapper around window.apiClient for site endpoints. Exposed on
 * window.siteApi (no ES modules in this codebase yet — same loadOnce
 * pattern as detail-location-map.js).
 *
 * Each method returns a Promise resolving to the parsed `data` payload, or
 * { turboStream: true } when the server returned a Turbo Stream and Turbo
 * has rendered it. Errors throw with .message, .status, and .details set.
 */
loadOnce('site-api', function () {
    var request = window.apiClient.request;

    window.siteApi = {
        list: function (clientId) {
            return request('GET', '/client/' + encodeURIComponent(clientId) + '/sites', null, { acceptStream: false });
        },
        create: function (clientId, data, opts) {
            return request('POST', '/client/' + encodeURIComponent(clientId) + '/sites', data, opts);
        },
        update: function (siteId, data, opts) {
            return request('PUT', '/sites/' + encodeURIComponent(siteId), data, opts);
        },
        setActive: function (siteId, isActive, opts) {
            return request('POST', '/sites/' + encodeURIComponent(siteId) + '/active', { is_active: isActive }, opts);
        },
        remove: function (siteId, opts) {
            return request('DELETE', '/sites/' + encodeURIComponent(siteId), null, opts);
        }
    };
});
